import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class OrangeCardDto extends GameFactEventDto {

  constructor(event) {
    super(event);
    this.tab = event.tab ?? "CARTON ORANGE";
    this.detail = {
      ...(this.detail || {}),
      title : event.detail?.title || "CARTON ORANGE",
      player: event.detail?.player,
      reason: event.detail?.reason,
    };
  }

  get player() {
    return this.detail.player;
  }
  set player(value) {
    this.detail.player = value;
  }

  get reason() {
    return this.detail.reason;
  }
  set reason(value) {
    this.detail.reason = value;
  }

  initTimerPeriod(match) {
    super.initTimerPeriod(match);
  }

  updateDetail(key, value, match) {
    super.updateDetail(key, value);

    // Génération auto du texte
    if (this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player", "reason"].includes(key)) {
      let commentaire = "Carton orange";

      const team = getTeam(this.team, match);
      const cardPlayer = getPlayer(this.player, match, team);

      if (this.player) {
        if (cardPlayer) {
          commentaire += ' pour ' + cardPlayer.lastname;
        }
      } else if (team) {
        commentaire += ' pour ' + team.name;
      }

      commentaire += "! ";

      if (this.reason) {
        switch (this.reason) {
          case 'horsjeu':
            commentaire += 'Raison : Hors jeux.';
            break;
          case 'maulecroule':
            commentaire += 'Raison : Maul écroulé.';
            break;
          case 'meleeecroule':
            commentaire += 'Raison : Mêlée écroulée.';
            break;
          case 'plaquageanticipe':
            commentaire += 'Raison : Plaquage anticipé.';
            break;
          case 'tenirleballon':
            commentaire += 'Raison : Tenir le ballon.';
            break;
          case 'jeudeloyal':
            commentaire += 'Raison : Jeu déloyal.';
            break;
          default:
            break;
        }
      }

      this.text = commentaire;
    }
  }
}
